// @flow
import React, { Component } from 'react';

import { getPublicAssets } from 'utils/assetsUtils';

import './CompetitionsInternationalesSingleMatchEmptyState.css';

type Props = {
  description: string,
  titleFirstPart: string,
  titleSecondPart: string,
  backgroundImage: string
};

class CompetitionsInternationalesSingleMatchComposition extends Component<Props> {
  render() {
    const { backgroundImage, description, titleFirstPart, titleSecondPart } = this.props;

    return (
      <div className="match-single-empty-state">
        <div
          className="match-single-empty-state-background"
          style={{ backgroundImage: `url(${getPublicAssets(backgroundImage)})` }}
        ></div>
        <div className="content">
          <h2 className="divided">
            <span className="first">{titleFirstPart}</span>
            <span className="second">{titleSecondPart}</span>
          </h2>
          <p className="description">{description}</p>
        </div>
      </div>
    );
  }
}

export default CompetitionsInternationalesSingleMatchComposition;
